module.exports = __webpack_public_path__ + "static/img/after_sale_starton-1.5980bde1.png";